import React, { useEffect, useState, useContext, useCallback } from "react";
import { ClientContext } from "../../context/Client/ClientContext";
import AttributeList from "./AttributeList";
import ClassList from "./ClassList";
import DepartmentList from "./DepartmentList";

const Categories = () => {
  const [deptId, setDeptId] = useState(null);
  const [hideDepartments, setHideDepartments] = useState(false);

  const {
    isClientSelected,
    showClientList,
    hideClientList,
    clearSelectedClass,
    getClientsByAttributes,
    clearSelectedClient,
    getAllCategories,
    categories,
    setSelectedDepartment,
    getClasses,
    classes,
    selectedDepartment,
    getAttributes,
    classAttributes,
    setSelectedAttributes,
    selectedAttributes,
    isClassSelected,
  } = useContext(ClientContext);

  const handleHideDepartments = useCallback(() => {
    setHideDepartments(Boolean(selectedDepartment && window.innerWidth < 600));
  }, [selectedDepartment]);

  useEffect(() => {
    getAllCategories();
  }, [getAllCategories]);

  useEffect(() => {
    handleHideDepartments();

    window.addEventListener("resize", handleHideDepartments);

    return () => {
      window.removeEventListener("resize", handleHideDepartments);
    };
  }, [handleHideDepartments]);

  const handleDeptClick = (id) => {
    setSelectedDepartment(id);
    clearSelectedClass();
    setDeptId(id);
    getClasses(id);

    clearSelectedClient();
    setSelectedAttributes([]);
    hideClientList();
  };

  const handleClassClick = (id) => {
    getAttributes(id);
    setSelectedAttributes([]);
  };

  const handleAttributeSelectionChange = (e) => {
    const attributeId = Number(e.target.id);

    if (e.target.checked) {
      setSelectedAttributes([...selectedAttributes, attributeId]);
    } else {
      setSelectedAttributes(
        selectedAttributes.filter((att) => att !== attributeId)
      );
    }
  };

  const handleAttrSearch = async () => {
    clearSelectedClient();

    await getClientsByAttributes(selectedAttributes);

    showClientList();
  };

  return (
    <div className="gog-dept-category-flow">
      <div className="gog-dept-flow-header">
        <span>Category Search</span>
        <h3>Browse by Category, Type & Attributes</h3>
        <p>
          Select a category, choose the business type, then add any must-have
          attributes to find matching merchants.
        </p>
      </div>

      <div className="gog-dept-progress">
        <div className={selectedDepartment ? "complete" : "active"}>
          <strong>1</strong>
          <span>Category</span>
        </div>

        <div className={isClassSelected ? "complete" : ""}>
          <strong>2</strong>
          <span>Type</span>
        </div>

        <div className={selectedAttributes.length > 0 ? "complete" : ""}>
          <strong>3</strong>
          <span>Attributes</span>
        </div>
      </div>

      <div className="gog-dept-columns">
        {!hideDepartments && (
          <div className="gog-dept-column-card">
            <DepartmentList
              departmentList={categories}
              handleDeptClick={handleDeptClick}
            />
          </div>
        )}

        {selectedDepartment && (
          <div className="gog-dept-column-card">
            <ClassList
              classList={classes}
              deptId={deptId}
              handleClassClick={handleClassClick}
            />
          </div>
        )}

        {isClassSelected && (
          <div className="gog-dept-column-card">
            <AttributeList
              attributes={classAttributes}
              handleCheckChange={handleAttributeSelectionChange}
              selectAttributes={selectedAttributes}
            />
          </div>
        )}
      </div>

      {isClassSelected && (
        <div className="gog-dept-actions">
          <button
            type="button"
            className="gog-primary-btn"
            onClick={handleAttrSearch}
          >
            Search
          </button>
        </div>
      )}

      {isClientSelected && (
        <div className="gog-dept-note">
          A merchant is selected in the results panel. Use the result action to
          continue to the merchant page.
        </div>
      )}
    </div>
  );
};

export default Categories;